import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationTemplateFacade } from 'src/app/store/notification-template/facade';
import { ParameterModel } from 'src/app/store/notification-template/model';

@Component({
  selector: 'app-notification-template-key-words-details',
  templateUrl: './notification-template-key-words-details.component.html',
  styleUrls: ['./notification-template-key-words-details.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class NotificationTemplateKeyWordsDetailsComponent implements OnInit {
  private notificationTemplateFacade = inject(NotificationTemplateFacade);

  keyWords$: Observable<ParameterModel[]>;
  expanded: boolean = false;

  ngOnInit(): void {
    this.keyWords$ = this.notificationTemplateFacade.parameters$;
    this.notificationTemplateFacade.loadParameters();
  }

  public getIcon(): string {
    return this.expanded ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down';
  }

  public getFormatedKeyWord(keyWord: string): string {
    return `#${keyWord}#`;
  }

  public rowClick($event) {
    // $event.event.preventDefault();
    // $event.event.stopPropagation();

    this.copyToClipboard(this.getFormatedKeyWord($event.data.name));
  }

  public copyToClipboard(item: string) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', item);
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
  }
}
